// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"EditPopup_deleteButton__3CC_K","field":"EditPopup_field__S3nue","text":"EditPopup_text__2mW8o"};